export enum InquiryStatus {
  Inquiry = 'Inquiry',
  Answered = 'Answered',
  Completed = 'Completed',
  UserInquiry = 'UserInquiry',
}
